import axios from '@/fetch';
const {
  get,
  post,
  put,
  del,
  getStream
} = axios;
const branchUrl = "/question";
const saasBusinessUrl = "/saas-business";
const externalUrl = "/external";
const courseUrl = "/course";
const resourceUrl = "/resource";
const domain = window.location.host.indexOf('localhost') == -1 ? window.location.origin : 'http://wxrcc.rel-s.yunduoketang.cn';
const domainNoHTP = window.location.host.indexOf('localhost') == -1 ? window.location.host : 'wxrcc.rel-s.yunduoketang.cn'; // 头部设置

export function getIcoAndCompanyName() {
  return get(saasBusinessUrl + `/v1/company/config/c/meta/data?domain=${domain}`);
} // 注册配置

export function getRegisterConfig() {
  return get(`${saasBusinessUrl}/v1/company/register/config`);
}
/*-----------题库----------*/
// 新网校题库
// 题库统计

export function getCateStatis() {
  return get(branchUrl + '/v1/question/front/user/statistics');
} //已做题库数据列表

export function getCategoryList(page, pageSize) {
  return get(branchUrl + '/v1/question/front/user/studied/categories?page=' + page + '&pageSize=' + pageSize + '&ram=' + Math.random());
} //可做题库数据列表

export function getAllCategoryList(page, pageSize) {
  return get(branchUrl + '/v1/question/front/user/all/categories?page=' + page + '&pageSize=' + pageSize + '&ram=' + Math.random());
} //剩余体验天数

export function getRestDays(page, pageSize) {
  return get(branchUrl + '/v1/question/front/user');
}
/*-----------我的考试----------*/
//考试列表

export function getMyExamList(examType, examState, pageIndex, pageSize, examName) {
  return get(branchUrl + '/api/v1/front/exam/queryMyExamList?examType=' + examType + '&examState=' + examState + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&examName=' + examName + '&ram=' + Math.random());
} //考试介绍

export function getExamIntro(examId) {
  return get(branchUrl + '/api/v1/front/exam/queryDetail/' + examId);
} //是否超出考试次数

export function getUserExamCount(examId, paperId) {
  return get(branchUrl + '/api/v1/front/exam/queryUserExamCount/' + examId + '/' + paperId);
} //考试记录

export function getExamRecord(examId, pageIndex, pageSize) {
  return get(branchUrl + '/api/v1/front/exam/queryExamRecord/' + examId + '?pageIndex=' + pageIndex + '&pageSize=' + pageSize);
} //考试作答报告(证书、抽题类)

export function handInPaper(exerciseId) {
  return get(branchUrl + '/api/v1/front/exam/handInPaper/' + exerciseId);
} //考试作答报告(付费类)

export function handInPaperPay(exerciseId) {
  return get(branchUrl + '/api/v1/front/exam/handInPaper/pay/' + exerciseId);
} //申请批阅

export function applyMark(params) {
  return post(branchUrl + '/api/v1/front/question/makePayOrder/' + params.exerciseId + "?domain=" + params.domain);
} //点参加考试，获取recordId

export function getRecordId(params) {
  return post(branchUrl + '/api/v1/front/exam/joinExam', params);
} //付费批卷——支付结果页面信息

export function getPayResultData(params) {
  return get(branchUrl + '/api/v1/front/question/done', params);
} //查询付费批阅考试数据

export function getExamPayInfo(examId) {
  return get(branchUrl + `/api/v1/examUser/queryPayInfo/${examId}`);
} //查询学员是否完善信息

export function dataIsExists() {
  return get(saasBusinessUrl + `/v1/longitudinalTableColDefine/dataIsExistsPerfectInfo?domain=${domain}`);
} //保存完善信息

export function updateBaseInfoAndCustomInfo(params) {
  return post(saasBusinessUrl + `/v1/longitudinalTableColDefine/updateBaseInfoAndCustomInfo?domain=${domain}`, params);
} //证书列表

export function getCerList(params) {
  return get(`${saasBusinessUrl}/v1/certificate/get/cer/list?domain=${domain}&status=${params.status}`);
} //下载证书

export function loadCertificate(params) {
  return getStream(saasBusinessUrl + '/v1/certificate/download/certificate/', params);
} //获取证书需要解锁的字段

export function unlockFiedld(params) {
  params.domain = domain;
  return get(saasBusinessUrl + '/v1/certificate/get/unlock/field/', params);
} //解锁证书

export function unlockCertificate(params, relationIds) {
  let str = '';
  str = relationIds.join();
  return post(`${saasBusinessUrl}/v1/certificate/update/student?domain=${domain}&relationIds=${str}`, params);
} //获取证书数量

export function getCerCount(params) {
  return get(saasBusinessUrl + '/v1/certificate/get/cer/count/', params);
} //获取证书未读数量

export function getUnread() {
  return get(saasBusinessUrl + '/v1/certificate/get/unread/count');
} //生成证书

export function createCer() {
  return post(`${saasBusinessUrl}/v1/certificate/create/certificate?domain=${domain}`);
} //订单列表

export function getOrderList(params) {
  return post(`${saasBusinessUrl}/v1/payOrder/findOrderList?domain=${domain}`, params);
} //订单统计数量

export function getOrderCount(params) {
  return get(saasBusinessUrl + '/v1/payOrder/countUserOrderStatus/', params);
} //订单详情

export function getOrderDetail(params) {
  return get(`${saasBusinessUrl}/v1/payOrder/findOrderById?domain=${domain}`, params);
} //取消订单

export function abolishOrder(params) {
  return get(`${saasBusinessUrl}/v1/payOrder/abolishOrder?domain=${domain}`, params);
} //获取发票功能是否开启

export function getInvoiceFunction() {
  return get(`${saasBusinessUrl}/v1/invoice/getInvoiceFunction?domain=${domain}`);
} //获取学员发票模板数据

export function getTemplate(params) {
  return get(`${saasBusinessUrl}/v1/invoice/template?domain=${domain}`, params);
} //保存发票模板数据

export function saveOrUpdateTemplate(params) {
  return post(`${saasBusinessUrl}/v1/invoice/saveOrUpdateTemplate?domain=${domain}`, params);
} //开发票详情数据

export function companyInvoice(params) {
  return get(`${saasBusinessUrl}/v1/invoice/companyInvoice?domain=${domain}`, params);
} //开发票保存

export function saveCompanyInvoice(params) {
  return post(`${saasBusinessUrl}/v1/invoice/saveCompanyInvoice?domain=${domain}`, params);
}
export function studentCount(params) {
  return get(saasBusinessUrl + "/v1/student/message/count");
} //个人中心-我的消息已读未读

export function getMessageRead(params) {
  return get(saasBusinessUrl + '/v1/student/message/count');
} //个人中心-我的消息列表

export function getMessageList(params) {
  return get(saasBusinessUrl + '/v1/student/message/page', params);
} //个人中心-我的消息读取消息

export function readMessage(messageId) {
  console.log(messageId, "?messageId??");
  return post(saasBusinessUrl + `/v1/student/message/read/${messageId.messageId}`);
} //个人中心-我的消息删除消息

export function deleteMessage(messageId) {
  return del(saasBusinessUrl + `/v1/student/message/delete/${messageId.messageId}`);
} //获取当前用户信息

export function getCurrentUser() {
  return get(externalUrl + '/api/v1/usersfront/getCurrentUser');
} // 个人设置相关
// 个人中心左侧菜单权限

export function personalLeftMenu(params) {
  return get(`${saasBusinessUrl}/v1/user-center/service/config`, params);
} // 获取账号信息

export function getAccountInfo(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/get/account/info`, params);
} // 校验邮箱是否已绑定

export function checkEmail(params, domain) {
  return post(`${saasBusinessUrl}/v1/student/setting/check/email?domain=${domain}`, params);
} // 校验用户名是否已绑定

export function checkUserName(params, domain) {
  return post(`${saasBusinessUrl}/v1/student/setting/check/username?domain=${domain}`, params);
} // 校验手机号是否已绑定

export function checkMobile(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/check/mobile?domain=${domain}`, params);
} // 绑定邮箱

export function bindEmail(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/bind/email?domain=${domain}`, params);
} // 绑定手机号

export function bindMobile(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/bind/mobile?domain=${domain}`, params);
} // 绑定用户名

export function bindUsername(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/bind/username?domain=${domain}`, params);
} // 修改绑定前 身份验证

export function verifyUserIdent(params, domain) {
  return post(`${saasBusinessUrl}/v1/student/setting/verifyIdentidy?domain=${domain}`, params);
} // 图形验证码

export function getCaptcha(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/get/captcha`, params);
} // 修改密码

export function modifyPassword(params, domain) {
  return post(`${saasBusinessUrl}/v1/student/setting/update/password?domain=${domain}`, params);
} // 第三方账号绑定

export function bindThirdAccount(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/bind/third/party/account?domain=${domain}`, params);
} // 第三方账号解绑

export function unBindThirdAccount(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/unbind/third/party/account?domain=${domain}`, params);
} // 获取代报考资料列表

export function getInsteadList(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/get/sign/source`, params);
} // 获取代报考资料填写字段

export function getInsteadField(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/get/sign/source/data`, params);
} // 代报考填写提交POST

export function insteadUpload(params, domain) {
  return post(`${saasBusinessUrl}/v1/student/setting/save/sign/sourse?domain=${domain}`, params);
} // 设置头像

export function settingAvatar(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/head/portrait?domain=${domain}`, params);
} // 获取短信验证码

export function getMessageCode(params, domain) {
  return post(`${saasBusinessUrl}/v1/student/setting/send/sms?domain=${domain}`, params);
} // 获取滑块坐标GET

export function getSliderPosition(params) {
  console.log(params, 'getSliderPositiongetSliderPosition');
  return get(`${saasBusinessUrl}/v1/student/setting/get/captcha/positon`, params);
} // 滑块坐标验证

export function checkSliderCaptcha(params) {
  console.log(params, 'checkSliderCaptchacheckSliderCaptcha');
  return get(`${saasBusinessUrl}/v1/student/setting/check/captcha/position`, params);
} // 数字验证码验证

export function checkCaptcha(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/check/captcha`, params);
} // 获取个人资料

export function getPersonalData(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/get/detail`, params);
} // 获取个人资料自定义字段

export function getCustomizeFields(params) {
  return get(`${saasBusinessUrl}/student/getCustomizeFields?stuId=${params.stuId}&schoolId=${params.schoolId}&domain=${domain}`);
} // 保存个人资料基本信息

export function savePersonalDataBasic(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/save/base/info?domain=${domain}`, params);
} // 保存个人资料联系信息

export function savePersonalDataContact(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/save/contact/info?domain=${domain}`, params);
} // 保存个人资料其他信息

export function savePersonalDataOther(params, domain) {
  return put(`${saasBusinessUrl}/v1/student/setting/save/other/info?domain=${domain}`, params);
} // 保存个人资料自定义信息

export function savePersonalDataCustom(params, data) {
  return put(`${saasBusinessUrl}/student/improve/custom/info?domain=${domain}&company_id=${params.companyId}&school_id=${params.schoolId}&user_id=${params.userId}`, data);
} // 图片上传

export function uploadCycles(params) {
  let currentDomain = window.location.origin.indexOf('localhost') == -1 ? `${window.location.origin}/s/api/saas-business` : 'http://dev-s.yunduoketang.cn/s/api/saas-business';
  return `${currentDomain}/v1/companyBannerTemplateConfig/uploadCycles`;
} // 保存学员注册信息

export function savePersonalDataRegister(params) {
  return put(`${saasBusinessUrl}/v1/student/setting/save/register/info?domain=${params.domain}&stuId=${params.stuId}&groupOneId=${params.groupOneId}`, params);
} // 获取个人资料其他信息字段值

export function getOtherFieldValue(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/get/custom/field/data`, params);
} // 获取资源详情 如附件

export function getResourceDetail(params) {
  return get(`${saasBusinessUrl}/v1/resource/detail/${params.id}?domain=${params.domain}`);
} // 附件资源下载

export function downloadResource(id, domain) {
  return get(`${saasBusinessUrl}/v1/resource/download/${id}?domain=${domain}`);
} //附件图片预览

export function previewResource(id, domain) {
  return get(`${saasBusinessUrl}/v1/resource/view/${id}?domain=${domain}`);
}
/*-----------学习问答----------*/
// 我的提问

export function getMyQuestion(data) {
  return post(saasBusinessUrl + `/v1/question/findMyQuestion`, data);
} // 我的回答

export function getMyAnswers(data) {
  return post(saasBusinessUrl + `/v1/question/findMyAnswers`, data);
} // 提问回答统计

export function getQACount(data) {
  return post(saasBusinessUrl + `/v1/question/countMyQuestion`, data);
} // 左侧问答小红点

export function findUnReadCount(data) {
  return get(saasBusinessUrl + `/v1/question/findUnReadCount`, data);
} // 小组统计

export function getGroupCount(data) {
  return get(saasBusinessUrl + `/v1/companyGroup/countUserOrderStatus`, data);
} // 我创建的小组

export function getMyCreateGroups(data) {
  return get(saasBusinessUrl + `/v1/companyGroup/getMyCreateGroups`, data);
} // 我加入的小组

export function getMyJoinGroups(data) {
  return get(saasBusinessUrl + `/v1/companyGroup/getMyJoinGroups`, data);
} // 我的话题

export function getMyTopics(data) {
  return get(saasBusinessUrl + `/v1/companyGroup/getMyTopics`, data);
} // 我的资料列表

export function getResource(data) {
  return post(saasBusinessUrl + `/v1/resource/selectAll`, data);
} // 获取资源存储大小

export function getResourceSize(data) {
  return get(saasBusinessUrl + `/v1/resource/list`, data);
} // 上传资源前判断空间大小

export function getSpaceSize(domain) {
  return post(saasBusinessUrl + `/v1/resource/getSpaceSize?domain=${domain}`);
} // 上传资源前判断是否为会员

export function getVipFlag(data) {
  return get(saasBusinessUrl + `/v1/resource/getVipFlag`, data);
} // 上传科目

export function loadOption(data) {
  return post(saasBusinessUrl + `/v1/resource/loadOption`, data);
} // 获取token

export function getUpToken() {
  return post(saasBusinessUrl + `/v1/resource/getuptoken?domain=${domain}`);
} // 获取domain

export function toUpload() {
  return post(saasBusinessUrl + `/v1/resource/toUpload?domain=${domain}`);
} // 文件上传完成

export function toSave(data) {
  return post(saasBusinessUrl + `/v1/resource/save?domain=${domain}`, data);
} // 文件上传完成新

export function toSaveFile(data, domain) {
  return post(saasBusinessUrl + `/v1/longitudinalTableColDefine/uploadsave?domain=${domain}`, data);
} // 删除文件

export function delResource(data, domain) {
  return post(saasBusinessUrl + `/v1/resource/delResource?resourceId=${data}&domain=${domain}`);
} // 学习问答-作业-作业列表

export function getHomeworkList(params) {
  return post(saasBusinessUrl + `/v1/homeworkStudentComplete/queryStudentClassOrPackageLessonList?domain=${domain}`, params);
} // 获取作业tab个数

export function getHomeworkListCount(params) {
  return post(saasBusinessUrl + `/v1/homeworkStudentComplete/queryStudentClassOrPackageLessonCount?domain=${domain}`, params);
} // 学习问答-作业-下拉框列表

export function getHomeworkSelectList() {
  return get(saasBusinessUrl + `/v1/homeworkStudentComplete/queryStudentCourseIds?domain=${domain}`);
} // 学习问答-作业-检查能否提交课后作业

export function getCheckAfterWork() {
  return post(saasBusinessUrl + `/v1/homework/checkCanSubmitHomework?domain=${domain}`);
} // 作业-删除文件

export function deleteReslist() {
  return post(saasBusinessUrl + `/v1/homework/delreslist`);
} // 查询作业问答

export function checkAskAndAnswer(params) {
  return post(saasBusinessUrl + `/v1/homework/getStudentHomeworkList?domain=${domain}`, params);
} // 学习问答-作业-查看批阅-重新编辑

export function getRedAndEdit(params) {
  return get(saasBusinessUrl + `/v1/homework/gotoFinishHomeworkPage/${params.homeworkId}`, params);
} // 学习问答-作业-试卷

export function getHomeworkTestPaper(data) {
  return get(saasBusinessUrl + `/v1/homework/gotoPaperHomeworkPage`, data);
} // 作业上传保存

export function setHomeworkUpload(params) {
  return post(saasBusinessUrl + `/v1/homework/homeworkUpload`);
} // 学习问答-提交作业

export function setHomework(params) {
  return post(saasBusinessUrl + `/v1/homework/saveHomework?domain=${params.domain}`, params);
} // z作业附件

export function getHomeworkAppendices(params) {
  return post(saasBusinessUrl + `/v1/homework/preview?types=work&id=${params.id}&domain=${params.domain}`);
} // 作业图片上传

export function setUplaodHomeworkImg(params) {
  return post(saasBusinessUrl + `/v1/homework/uplaodHomeworkImg`, params);
} //作业= 回显

export function getShowHomework(params) {
  return post(saasBusinessUrl + `/v1/homework/getStuHomeworkDetail?id=${params.id}&domain=${params.domain}`);
} // 保利威视上传
// export function getBlvsMessage() {
// 	return get(saasBusinessUrl +`/v1/homework/validateBLVS`)
// }
// // 保利威视回调
// export function setBlvsMessage(params) {
// 	return post(saasBusinessUrl +`/v1/homework/blvsUploadSuccess`,params)
// }
// 保利威视上传

export function getBlvsMessage() {
  return get(resourceUrl + `/platform/blvs/authorizations`);
} // 保利威视回调

export function setBlvsMessage(params, domain) {
  console.log(domain, '123123domaindomaindomaindomain');
  return post(saasBusinessUrl + `/v1/homework/blvsUploadSuccess?domain=${domain}`, params);
} // cc获取存储 POST /v1/homework/uploadVideo/judgeVideoStorage

export function getVideoStorage(params) {
  return post(saasBusinessUrl + `/v1/homework/uploadVideo/judgeVideoStorage?totalSize=${params.totalSize}&domain=${params.domain}`);
} //获取bjy上传参数

export function getBjyQuery(params) {
  return post(`${saasBusinessUrl}/v1/homework/getUpBjySign?domain=${params.domain}&file_name=${params.file_name}`);
} //获取百家云授权

export function getBjyCtrl(params) {
  return get(`${resourceUrl}/platform/baijiayun/authorizations?file_name=${params.file_name}`);
} //百家云上传成功

export function getBjySuccess(params) {
  return post(`${saasBusinessUrl}/v1/homework/getBjyResumSign?domain=${params.domain}&video_id=${params.video_id}`);
} // 百家云回调

export function setBjySuccessCalback(params, domain) {
  return post(`${saasBusinessUrl}/v1/homework/bjyUploadSuccess?domain=${domain}`, params);
} // POST /v1/homework/uploadVideo/uploadToCC

export function setCCVideo(params, domain) {
  return post(saasBusinessUrl + `/v1/homework/uploadVideo/uploadToCC?domain=${domain}`, params);
} // 获取cc场景授权

export function bokecc(params) {
  console.log(params);
  return get(`${resourceUrl}/platform/bokecc/authorizations`, params);
} // 修改cc视频资源状态

export function udpateCCStatus(params, domain) {
  return post(saasBusinessUrl + `/v1/homework/udpateCCStatus/udpateCCStatus/${params.ccvid}?domain=${domain}`);
} // 删除文件

export function deleteHomeworkFile(params) {
  return post(saasBusinessUrl + `/v1/homework/delreslist?id=${params.id}&domain=${params.domain}`);
} // 上传文件

export function uploadHomeworkFile(params) {
  return post(saasBusinessUrl + `/v1/homework/homeworkUpload`, params);
} // 下载图片

export function setdownloadImg(data) {
  return get(saasBusinessUrl + `/v1/homework/downloadImage?imgUrl=${data.imgUrl}&imgName=${data.imgName}`);
} // 我的作业新消息

export function getHomeworkNewMsg(data) {
  return post(saasBusinessUrl + `/v1/homework/findHomeworkLeaveNotifyByUserId?domain=${data.domain}`);
}
/**
 * 课程中心
 */
// 课程表

export function getTimetable(params) {
  return post(`${saasBusinessUrl}/v1/course/centre/get/user/timetable`, params);
} // 课程表 - 课程列表

export function getTableCourse(params) {
  return post(`${saasBusinessUrl}/v1/course/centre/get/user/course/by/timetable?domain=${domain}`, params);
} // 课程  列表

export function getUserCourse(params) {
  return get(`${courseUrl}/v1/user/get/courses`, params);
} // 课程包  列表

export function getUserPackages(params) {
  return get(`${courseUrl}/v1/user/get/course/packages`, params);
} // 笔记关联的课程列表

export function getNotesCourse(params) {
  return get(`${saasBusinessUrl}/v1/user-center/note/course`, params);
} // 笔记关联的课次列表

export function getNotesLecture(params) {
  return get(`${saasBusinessUrl}/v1/user-center/note/lecture/${params.classTypeId}?domain=${params.domain}`);
} // 笔记 列表

export function getUserNotes(params) {
  return get(`${saasBusinessUrl}/v1/user-center/note/search`, params);
} // 笔记 删除

export function delUserNotes(params) {
  return del(`${saasBusinessUrl}/v1/user-center/note/remove/${params.noteId}?domain=${params.domain}`);
} // 笔记 编辑

export function editUserNotes(params) {
  return post(`${saasBusinessUrl}/v1/user-center/note/update?domain=${params.domain}`, params);
} // 收藏 类型个数

export function getCollectNum(params) {
  return get(`${saasBusinessUrl}/v1/user-center/collect/classify`, params);
} // 收藏 课程列表

export function getCollectCourse(params) {
  return get(`${saasBusinessUrl}/v1/user-center/collect/search`, params);
} // 收藏 取消收藏课程

export function delCollectCourse(params) {
  return del(`${saasBusinessUrl}/v1/user-center/collect/remove/${params.collectId}?domain=${params.domain} `);
} // 收藏 课程包列表

export function getCollectPackage(params) {
  return get(`${saasBusinessUrl}/v1/user-center/collect/package/search`, params);
} // 收藏 取消收藏课程包

export function delCollectPackage(params) {
  return del(`${saasBusinessUrl}/v1/user-center/collect/package/remove/${params.collectId}?domain=${params.domain}`);
} // 积分卡 验证学习码是否有效

export function cardCheckCode(params) {
  return post(`${saasBusinessUrl}/v1/study/card/check/code?domain=${params.domain}&code=${params.code}`);
} // 创建学习卡订单

export function cardCreateOrder(params) {
  return post(`${saasBusinessUrl}/v1/study/card/create/order?domain=${params.domain}`, params);
} // 兑换之后课程列表

export function cardGetInfo(params) {
  return get(`${saasBusinessUrl}/v1/study/card/get/return/info`, params);
} // 兑换之后课程包列表

export function cardPackageInfo(params) {
  return get(`${saasBusinessUrl}/v1/study/card/get/class/package/info`, params);
} // 最近学习

export function lateLearn(params) {
  return get(`${courseUrl}/v1/user/lately/learn/course`, params);
} // 检测是否签署协议

export function checkShowProtocol(params) {
  return post(`/coursePotocolUserRelation/checkShowProtocol?useTime=1`, params);
} // 检测资料是否完善

export function validatePerfect(params) {
  return get(`/student/validatePerfectStudentInfo/${params.id}/0`, params);
} // 提交同意协议

export function submitProtocol(params) {
  return post(`/coursePotocolUserRelation/insertProtocol`, params);
} // 提交完善的用户信息

export function submitPerInfo(params) {
  return post(`/student/perfectStudentInfo`, params);
} // 进入直播间 待报考

export function insteadSign(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/check/instead/sign/status`, params);
} // GET /v1/user/get/course/buy/source/{classTypeId}

export function buySource(classTypeId, params) {
  return get(`${courseUrl}/v1/user/get/course/buy/source/${classTypeId}`, params);
}
/*-----------账户中心---------*/
// 获取会员列表

export function getMemberList(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/member/list`, params);
} // 获取我的余额相关数据

export function getBalanceInfo(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/charge`, params);
} // 获取充值历史列表

export function getChargeHistoryList(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/charge/history/list`, params);
} // 获取我的积分信息

export function getScoreInfo(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/point/info`, params);
} // 获取我的积分列表

export function getScoreList(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/point/list`, params);
} // 获取积分说明

export function getScoreDesc(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/point/desc`, params);
} // 获取我的优惠券数量

export function getCouponCount(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/coupons/count`, params);
} // 获取我的优惠券列表

export function getCouponList(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/coupons/list`, params);
} // 兑换我的优惠券

export function exchangeCoupon(params) {
  return post(saasBusinessUrl + `/v1/account/exchange/coupons?domain=${domain}&code=${params.code}`);
} // 优惠卷绑定的课程列表

export function getCourseCoupon(couponId, params) {
  params.domain = domain;
  return get(`${saasBusinessUrl}/v1/account/couponCourseAjax/${couponId}`, params);
} // 获取我的邀请码

export function getInviteCode(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/personal/invite/code`, params);
} // 获取邀请记录和奖励

export function getInviteRecord(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/get/personal/record`, params);
} // 生成会员订单

export function makeMemberOrder(params) {
  return post(saasBusinessUrl + `/v1/account/make/member/order?domain=${domainNoHTP}&mem_id=${params.mem_id}&mem_type=${params.mem_type}`);
} // 充值余额生成订单

export function makeMoneyOrder(params) {
  return post(saasBusinessUrl + `/v1/account/make/order?domain=${domain}&balance=${params.balance}`);
} // 充值积分生成订单

export function makeScoreOrder(params) {
  return post(saasBusinessUrl + `/v1/account/make/point/order?domain=${domain}&point=${params.point}`);
} // 使用充值卡充值余额

export function useRechargeCard(params) {
  return post(saasBusinessUrl + `/v1/account/recharge/charge/card?domain=${domain}&code=${params.code}`);
} // 余额提现

export function cashWithDraw(params) {
  return post(saasBusinessUrl + `/v1/account/cash/withdraw?domain=${domain}&withdrawAmount=${params.withdrawAmount}`);
} // 校验是否允许提现

export function checkDrawMoney(params) {
  params.domain = domain;
  return get(saasBusinessUrl + `/v1/account/check/openid`, params);
} // 删除已过期优惠券

export function deleteExpiredCoupon(params) {
  return del(saasBusinessUrl + `/v1/account/delete/expire/coupon?domain=${domain}&user_front_coupons_id=${params.user_front_coupons_id}`);
} //刷新会员状态

export function refreshMemberStatus() {
  return get(saasBusinessUrl + `/v1/account/refresh/member/status?domain=${domain}`);
}
/*-----------旧网校题库----------*/
//已做题库数据列表

export function getOldCategoryList(page, pageSize, domain) {
  return get(saasBusinessUrl + `/v1/user-center/category/used/already?pageIndex=${page}&pageSize=${pageSize}&domain=${domain}`);
} //可做题库数据列表

export function getOldAllCategoryList(page, pageSize, domain) {
  return get(saasBusinessUrl + `/v1/user-center/category/used/can?pageIndex=${page}&pageSize=${pageSize}&domain=${domain}`);
} // 学员题库统计

export function getOldCateStatis(page, pageSize) {
  return get(saasBusinessUrl + `/v1/user-center/category/count`);
} // 我的考试

export function getOldMyExamList(examType, examState, pageIndex, pageSize, examName, domain) {
  return get(saasBusinessUrl + `/v1/user-center/category/exam?&pageIndex=${pageIndex}&pageSize=${pageSize}&domain=${domain}`);
} // 验证新旧网校访问题库

export function getNewOldType(domain) {
  return get(saasBusinessUrl + `/v1/user-center/category/handle/upgrade?domain=${domain}`);
} // 旧题库体验天数

export function oldGetRestDays(domain) {
  return get(saasBusinessUrl + `/v1/user-center/category/count?domain=${domain}`);
} // 获取机构APP配置

export function APPConfig() {
  return get(saasBusinessUrl + `/v1/company/config/app?domain=${domain}`);
}
/*-----------代报考相关----------*/
// 获取我的代报考列表

export function getMyInsteadSignList(params) {
  return get(`${saasBusinessUrl}/v1/front/instead/myInsteadSignList?domain=${domain}`, params);
} // 获取报考省份考点数据

export function getInsteadProvince(params) {
  return get(`${saasBusinessUrl}/v1/student/instead/get/sign/province?domain=${domain}`, params);
} // 添加省份考点

export function setInsteadProvince(params) {
  return put(`${saasBusinessUrl}/v1/student/instead/assign/examine/place/batch?domain=${domain}${params}`);
} // 获取学员代报考自定义字段

export function getInsteadValues(params) {
  return get(`${saasBusinessUrl}/v1/student/instead/get/sign/detail?domain=${domain}`, params);
} // 查询代报考下省份的开始和截止时间

export function getItemTimeByProvinceCode(params) {
  return get(`${saasBusinessUrl}/v1/front/instead/getItemTimeByProvinceCode?domain=${domain}`, params);
} // 获取我的代报考信息

export function getItemInfo(params) {
  return get(`${saasBusinessUrl}/v1/front/instead/getItemInfoByItemUserId?domain=${domain}`, params);
} // 保存代报考数据

export function saveItemFieldFormData(params) {
  return post(`${saasBusinessUrl}/v1/front/instead/saveItemFieldFormData?domain=${domain}`, params);
} // 获取代报考级联数据

export function setCascadeOptions(params) {
  return get(`${saasBusinessUrl}/v1/student/instead/get/cascade/options?domain=${domain}`, params);
} // 完善信息GET

export function getCustomizeInfo(params) {
  return get(`${saasBusinessUrl}/student/customize/info?domain=${domain}`, params);
} // 完善信息获取级联数据

export function getCustomizeOptionInfo(params) {
  return get(`${saasBusinessUrl}/v1/student/customize/option/${params.filedId}/${params.pid}?domain=${domain}`);
} // 保存用户自定义PUT

export function setImproveCustom(params, data) {
  return put(`${saasBusinessUrl}/student/improve/custom/info?domain=${domain}&company_id=${params.companyId}&school_id=${params.schoolId}&user_id=${params.userId}`, data);
} // 保存完善用户分组和代理机构

export function setStudentGroupAndProxyOrg(params, data) {
  return put(`${saasBusinessUrl}/student/improve/studentGroupAndProxyOrg/info?domain=${domain}&company_id=${params.companyId}&school_id=${params.schoolId}`, data);
} // 复制链接

export function saveUserItemRel(params) {
  return post(`${saasBusinessUrl}/v1/front/instead/saveUserItemRel?domain=${domain}&itemId=${params.itemId}&userId=${params.userId}&tk=${params.token}`);
} // 下载附件

export function getDownloadSpace(params) {
  return get(`${saasBusinessUrl}/v1/instead/sign/up/check/flow/spaceByCompanyId`, params);
}